import { render, staticRenderFns } from "./FilterDappSocial.vue?vue&type=template&id=541fa882&scoped=true"
import script from "./FilterDappSocial.vue?vue&type=script&lang=ts"
export * from "./FilterDappSocial.vue?vue&type=script&lang=ts"
import style0 from "./FilterDappSocial.vue?vue&type=style&index=0&id=541fa882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541fa882",
  null
  
)

export default component.exports